//This gets added to all Objects.
Object.defineProperty(Array.prototype, '_remove', {
    enumerable: false,
    value: function(itemToRemove: Object) {
        let index = this.indexOf(itemToRemove);
        this.splice(index, 1);
    }
});

//Assuming an object has an Id property to remove by.
Object.defineProperty(Array.prototype, '_removeObjectById', {
	enumerable: false,
	value: function (id:number) {
		let index = this.findIndex(a=> a.id === id);
		this.splice(index, 1);
	}
});

//Assuming an object has an Id property to find by.
Object.defineProperty(Array.prototype, '_findObjectById', {
	enumerable: false,
	value: function (id: number) {
		let index = this.findIndex(a => a.id === id);
		return this[index];
	}
});


Object.defineProperty(Array.prototype, '_add', {
    enumerable: false,
    value: function (itemToAdd: Object) {
        this.push(itemToAdd);
    }
});

Object.defineProperty(Array.prototype, '_move', {
	enumerable: false,
	value: function (from, to) {
		this.splice(to, 0, this.splice(from, 1)[0]);
	}
});


Object.defineProperty(Array.prototype, '_sortf', {
    enumerable: false,
    value: function (compare) { return [].concat(this).sort(compare); }
});


